module.exports = __webpack_public_path__ + "static/img/TudorDavid_BrechtNotes1961_1_FPO.3ce8ebb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/TudorDavid_BrechtNotes1961_1_FPO.jpg
// module id = Qq0Y
// module chunks = 0